import { Injectable } from '@angular/core';

/**
 * Minimal demo-grade auth. This is a CLIENT-SIDE gate for POC/demo only — it does NOT
 * secure the backend API (which is reachable independently). Replace with real auth (OIDC/SSO)
 * before any production use. Credentials are intentionally simple and visible on the login page.
 */
@Injectable({ providedIn: 'root' })
export class AuthService {
  /** Demo credentials. */
  private static readonly USER = 'demo';
  private static readonly PASS = 'watchdog';
  private static readonly KEY = 'wd-demo-auth';

  login(username: string, password: string): boolean {
    const ok = (username || '').trim().toLowerCase() === AuthService.USER
            && (password || '') === AuthService.PASS;
    if (ok) {
      sessionStorage.setItem(AuthService.KEY, '1');
    }
    return ok;
  }

  isLoggedIn(): boolean {
    return sessionStorage.getItem(AuthService.KEY) === '1';
  }

  logout(): void {
    sessionStorage.removeItem(AuthService.KEY);
  }
}
